<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'PrimaryButton',

    props: {
        btnTxt: {
            type: String,
            required: true
        }
    },

    emits: ['on-click']
})
</script>

<template>
    <button
        @click="$emit('on-click')"
        class="text-white bg-indigo-600 px-4 py-3 rounded-lg font-semibold text-xs md:text-sm cursor-pointer">
        {{btnTxt}}
    </button>
</template>